import { useState, type FormEvent } from "react";
import { post } from "../api";
import { safeStudentReturn } from "../passkeys";
import { Notice, StudentShell } from "../components/Layout";
import { useI18n } from "../i18n";

function fragmentToken() {
  const token = new URLSearchParams(window.location.hash.slice(1)).get("token") || "";
  if (token) history.replaceState(null, "", window.location.pathname);
  return token;
}

export function ClaimPage() {
  const { t } = useI18n();
  const [token] = useState(fragmentToken);
  const [error, setError] = useState("");
  const [working, setWorking] = useState(false);

  async function submit(event: FormEvent<HTMLFormElement>) {
    event.preventDefault();
    const form = new FormData(event.currentTarget);
    setWorking(true);
    setError("");
    try {
      const result = await post<{ returnTo?: string }>("/api/student/claim", { token, emailConsent: form.get("emailConsent") === "on" });
      window.location.replace(safeStudentReturn(result.returnTo));
    } catch {
      setError(t("error"));
    } finally {
      setWorking(false);
    }
  }

  return <StudentShell title={t("claimTitle")}><section className="student-card">
    {!token && <Notice kind="error">{t("invitationMissing")}</Notice>}
    {error && <Notice kind="error">{error}</Notice>}
    <p>{t("claimHelp")}</p>
    <form className="stack-form" onSubmit={submit}>
      <label className="check-label"><input name="emailConsent" type="checkbox" defaultChecked /> <span>{t("consent")}</span></label>
      <button className="primary-button" disabled={!token || working}>{working ? t("loading") : t("claim")}</button>
    </form>
  </section></StudentShell>;
}
